import classNames from 'clsx';
import React, { createRef } from 'react';

import Translation from '@swf/components/Translation/Translation';
import { Loader, NoData, useGetSortedClubs, usePollClubInfo } from '@swf/poker';

import useInviteToClub from '../Invite/useInviteToClub';

import AnimateClubs from './AnimateClubs/AnimateClubs';
import ClubItem from './ClubItem/ClubItem';
import CreateClubButton from './CreateClubButton/CreateClubButton';
import JoinClubButton from './JoinClubButton/JoinClubButton';
import {
  TXTWCL_No_Clubs_to_Show,
  TXTWCL_Your_clubs_will_be_shown_here
} from './MyClubs.messages.json';
import styles from './MyClubs.scss';
import useInitialClubLoading from './hooks/useInitialClubLoading';

const MyClubs: React.FC = () => {
  const { sortedClubs, loading: loadingSorted } = useGetSortedClubs();
  const hasClubs = !!sortedClubs.length;
  const loading = useInitialClubLoading(loadingSorted);

  usePollClubInfo();
  useInviteToClub();

  return (
    <div className={classNames(styles.container, { [styles.loading]: loading })}>
      <Loader loading={loading || loadingSorted}>
        {!hasClubs && (
          <NoData
            className={styles.noData}
            primaryText={<Translation {...TXTWCL_No_Clubs_to_Show} />}
            secondaryText={<Translation {...TXTWCL_Your_clubs_will_be_shown_here} />}
          />
        )}
        <div className={styles.buttons}>
          <JoinClubButton loading={false} />
          <CreateClubButton loading={false} />
        </div>
        {hasClubs && (
          <div className={styles.clubsContainer}>
            <AnimateClubs>
              {sortedClubs.map((club) => (
                <ClubItem key={club.clubId} ref={createRef()} {...club} />
              ))}
            </AnimateClubs>
          </div>
        )}
      </Loader>
    </div>
  );
};

export default MyClubs;
